import React from 'react';
import {
  InformationPageContentWrapper,
  InformationPageTitleText,
  InformationPagePageMainText,
  InformationPageButtonsContainer,
  InformationPageContainer,
} from './styles/informationPages.styles';
import { ErrorLicensePlatesIcon, ErrorLocationInterrisk, ErrorLocationTuw } from './styles/InformationPageIcons.styles';
import ReactMarkdown from 'react-markdown';
import { MakeCallButton } from '../../components/MakeCallButton/MakeCallButton';
import { useTypedTranslate } from '../../translations/useTypedTranslate';
import { Tenant, TENANT_NAME } from '../../config/tenants';

export const LocalizationErrorPage: React.FC = () => {
  const { t } = useTypedTranslate();

  return (
    <InformationPageContainer>
      <InformationPageContentWrapper>
        {TENANT_NAME === Tenant.INTER_RISK ? (
          <ErrorLocationInterrisk />
        ) : TENANT_NAME === Tenant.TUW ? (
          <ErrorLocationTuw />
        ) : (
          <ErrorLicensePlatesIcon />
        )}
        <InformationPageTitleText>{t('CAN_NOT_READ_LOCALIZATION')}</InformationPageTitleText>
        <InformationPagePageMainText>
          <ReactMarkdown>{t('MAKE_CALL_TO_ORDER_ASSISTANCE')}</ReactMarkdown>
        </InformationPagePageMainText>
        <InformationPageButtonsContainer>
          <MakeCallButton />
        </InformationPageButtonsContainer>
      </InformationPageContentWrapper>
    </InformationPageContainer>
  );
};
